(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('signyl-motion');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  var i = 0;
  document.querySelectorAll('[data-sr]').forEach(function (el) {
    el.style.setProperty('--sr-delay', ((i++ % 4) * 60) + 'ms');
    io.observe(el);
  });

  /* rules flow once as they enter */
  var rio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-flow');
      rio.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.sig-rule').forEach(function (r) { rio.observe(r); });

  /* 3 — bottle hover, upgraded 07-06 (Ben: bottles must move; the site is
     rich). Pointer-tracking tilt with inertial settle: the bottle leans
     toward the hand, lifts, and settles back on leave. Hover devices only. */
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.signyl-stage__media').forEach(function (host) {
      var img = host.querySelector('.signyl-stage__img');
      if (!img) return;
      var cur = { rx: 0, ry: 0, ty: 0, s: 1 };
      var goal = { rx: 0, ry: 0, ty: 0, s: 1 };
      var raf = null;
      function tick() {
        cur.rx += (goal.rx - cur.rx) * 0.14;
        cur.ry += (goal.ry - cur.ry) * 0.14;
        cur.ty += (goal.ty - cur.ty) * 0.14;
        cur.s  += (goal.s  - cur.s)  * 0.14;
        img.style.transform = 'perspective(900px) rotateX(' + cur.rx.toFixed(2) +
          'deg) rotateY(' + cur.ry.toFixed(2) + 'deg) translateY(' + cur.ty.toFixed(1) +
          'px) scale(' + cur.s.toFixed(3) + ')';
        var done = Math.abs(goal.rx - cur.rx) < 0.02 && Math.abs(goal.ry - cur.ry) < 0.02 &&
                   Math.abs(goal.ty - cur.ty) < 0.1 && Math.abs(goal.s - cur.s) < 0.002;
        if (done && goal.ry === 0 && goal.rx === 0 && goal.ty === 0) { raf = null; return; }
        raf = requestAnimationFrame(tick);
      }
      function wake() { if (!raf) raf = requestAnimationFrame(tick); }
      host.addEventListener('pointermove', function (e) {
        var r = host.getBoundingClientRect();
        goal.ry = ((e.clientX - r.left) / r.width - 0.5) * 12;
        goal.rx = ((e.clientY - r.top) / r.height - 0.5) * -8;
        goal.ty = -12;
        goal.s = 1.03;
        wake();
      });
      host.addEventListener('pointerleave', function () {
        goal.rx = 0; goal.ry = 0; goal.ty = 0; goal.s = 1;
        wake();
      });
    });
  }
})();
